import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { api } from '../services/api';

export function UserProfile() {
  const { user, getAccessTokenSilently } = useAuth0();
  const [username, setUsername] = useState('');
  const [currentUsername, setCurrentUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchCurrentUser();
  }, []);

  const fetchCurrentUser = async () => {
    try {
      const token = await getAccessTokenSilently();
      const userData = await api.getCurrentUser(token);
      setCurrentUsername(userData.username || '');
      setUsername(userData.username || '');
    } catch (err) {
      console.error('Failed to fetch user:', err);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Client-side validation
    const usernameRegex = /^[a-zA-Z0-9_-]+$/;
    if (!usernameRegex.test(username)) {
      setError('Username can only contain letters, numbers, underscores, and hyphens (no spaces)');
      setLoading(false);
      return;
    }

    try {
      const token = await getAccessTokenSilently();
      await api.updateUsername(username, token);
      setCurrentUsername(username);
      setSuccess('Username updated successfully!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err: any) {
      const errorMessage = err.message || 'Failed to update username';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-6 max-w-md">
      <h2 className="text-xl font-bold mb-4" style={{ color: '#111827' }}>Profile Settings</h2>
      
      <div className="mb-4">
        <p className="text-sm text-gray-600">Email</p>
        <p className="font-medium" style={{ color: '#111827' }}>{user?.email}</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
            Display Username
          </label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your username"
            minLength={3}
            maxLength={30}
            required
            style={{ color: '#111827', backgroundColor: '#ffffff' }}
          />
          <p className="mt-1 text-xs text-gray-500">
            3-30 characters. Letters, numbers, underscores (_), and hyphens (-) only. No spaces.
          </p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}

        {success && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-md">
            <p className="text-sm text-green-600">{success}</p>
          </div>
        )}

        <button
          type="submit"
          disabled={loading || username === currentUsername}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          {loading ? 'Updating...' : 'Update Username'}
        </button>
      </form>
    </div>
  );
}
